var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"standards-home"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-img',{attrs:{"src":_vm.titleImg,"max-height":"200","aspect-ratio":"1.5","position":"center left","gradient":"to right, rgba(0,0,0,.44), rgba(0,0,0,.44)"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7953d5f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/standards/Standards.vue
// module id = 511
// module chunks = 1